"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const subscriptionSlice_1 = require("../../../../redux/slices/subscriptionSlice");
const subscriptionPlanInfo_1 = __importDefault(require("./subscriptionPlanInfo"));
const subscription_1 = require("../../../../utils/subscription");
require("./plans.scss");
const Plans = (props) => {
    const { subscriptionData: subscription, userData, subscription: { hasCustomerId } } = props;
    const subscribed = subscription_1.isSubscribed(subscription);
    const renewalDate = subscription_1.renewDate(subscription);
    return (react_1.default.createElement("div", { className: 'plans-container' }, subscription && react_1.default.createElement(react_1.Fragment, null,
        (!subscribed && !renewalDate) && react_1.default.createElement(subscriptionPlanInfo_1.default, { title: 'Free', description: 'For solo attorneys or law firms getting started with practice management.', status: (!subscribed && !renewalDate) ? 'Current' : null, list: [
                { title: 'Matter Management', active: true },
                { title: 'Contact Management', active: true },
                { title: 'Client Management', active: true },
                { title: 'Litigation Calendar', active: true },
                { title: 'Set task start date & time', active: false },
                { title: 'Make matters, tasks and events private', active: false },
                { title: 'Automate workflow & calendaring', active: false },
                { title: 'Create unlimited custom tags', active: false },
                { title: 'Time Tracking', active: false },
                { title: 'Task/Event Dependencies', active: false }
            ], priceDetails: react_1.default.createElement("span", { className: "price" },
                react_1.default.createElement("span", { className: "price-first" }, "$ 0")) }),
        react_1.default.createElement(subscriptionPlanInfo_1.default, { isPaid: true, title: 'Early Bird', description: subscribed ?
                `Your plan will automatically renew on ${subscription_1.renewDate(subscription)}. You'll be charged US$ 7.95 per user, per month.` :
                'For law firms that need to manage their legal practice with confidence.', priceDetails: !subscribed && react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement("span", { className: "price" },
                    react_1.default.createElement("span", { className: "price-first" }, "$ 7"),
                    react_1.default.createElement("span", { className: "price-sec" }, " 95 ")),
                react_1.default.createElement("span", { className: "per" }, "per user, per month")), list: [
                { title: 'Matter Management', active: true },
                { title: 'Contact Management', active: true },
                { title: 'Client Management', active: true },
                { title: 'Litigation Calendar', active: true },
                { title: 'Set task start date & time', active: true },
                { title: 'Make matters, tasks and events private', active: true },
                { title: 'Automate workflow & calendaring', active: true },
                { title: 'Create unlimited custom tags', active: true },
                { title: 'Time Tracking', active: true },
                { title: 'Task/Event Dependencies', active: true },
            ], isSubscribed: subscribed, renewDate: renewalDate, trialUsed: subscription === null || subscription === void 0 ? void 0 : subscription.trial_used, onSubscribeAction: () => {
                if (hasCustomerId) {
                    if (subscription_1.ifMobile()) {
                        return props.toggleMobileInfoModal();
                    }
                    else {
                        return props.toggleSubscribeModal(false);
                    }
                }
                return window.location.href = `#/${(userData === null || userData === void 0 ? void 0 : userData.roleId) === 3 ? 'payment-history' : 'payment'}?showCardForm=true`;
            }, onUnsubscribeAction: () => props.unsubscribe(), onFreePlanAction: () => {
                if (hasCustomerId) {
                    if (subscription_1.ifMobile()) {
                        return !subscribed ? props.toggleMobileInfoModal() : false;
                    }
                    else {
                        return !subscribed ? props.toggleSubscribeModal(true) : false;
                    }
                }
                return window.location.href = `#/${(userData === null || userData === void 0 ? void 0 : userData.roleId) === 3 ? 'payment-history' : 'payment'}?showCardForm=true`;
            } }))));
};
const mapStateToProps = (state) => {
    const { subscription } = state;
    return {
        subscription
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        unsubscribe: () => dispatch(subscriptionSlice_1.unsubscribe()),
        getSubscription: () => dispatch(subscriptionSlice_1.getSubscription()),
        toggleSuccessModal: () => dispatch(subscriptionSlice_1.toggleSuccessModal()),
        toggleSubscribeModal: (trial) => dispatch(subscriptionSlice_1.toggleSubscribeModal(trial)),
        toggleMobileInfoModal: (data) => dispatch(subscriptionSlice_1.toggleMobileInfoModal(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Plans);
